module.exports = __webpack_public_path__ + "img/1b.f562052b.png";